import { getTokenPriceDisplayDecimals } from '@ui/utils/getTokenPriceDisplayDecimals';
import { isNil } from 'lodash-es';
import { useMemo } from 'react';

import { SupportedSymbol } from './price/priceLatest/store';
import { usePriceLatest } from './price/usePriceLatest';

export const useTokenDisplayDecimals = (
  symbol?: SupportedSymbol,
  priceDisplayDecimals?: number,
) => {
  const tokenPrice = usePriceLatest(symbol);

  return useMemo(() => {
    if (
      typeof priceDisplayDecimals === 'number' &&
      Number.isFinite(priceDisplayDecimals)
    ) {
      return priceDisplayDecimals;
    }

    // default 2
    if (isNil(tokenPrice) || isNaN(tokenPrice.toNumber())) return 2; // default 2

    return getTokenPriceDisplayDecimals(tokenPrice.toNumber());
  }, [priceDisplayDecimals, tokenPrice]);
};
